// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/feed/components/FeedTopicTag.module.css';
import {openFeedTopic} from '@app/features/feed/utils/FeedTopicUtils';
import {isFeedTopicsEnabled} from '@app/features/feed/utils/FeedUtils';
import type {FeedPostTopicResponse} from '@fluxer/schema/src/domains/feed/FeedTopicSchemas';
import {HashIcon} from '@phosphor-icons/react';
import {observer} from 'mobx-react-lite';

// Micup akis-gundem: the topic of a post in its header row, in place of its category (the topic brings it). A plain
// inline label (no measuring, no motion, no portal) that opens the topic page, an ended topic's too. onOpen runs first,
// so a card inside a modal closes the modal.
export const FeedTopicTag = observer(({topic, onOpen}: {topic: FeedPostTopicResponse; onOpen?: () => void}) => {
	if (!isFeedTopicsEnabled()) return null;
	const open = () => {
		onOpen?.();
		openFeedTopic(topic.id);
	};
	return (
		<button type="button" className={styles.tag} onClick={open} data-flx="feed.feed-topic-tag.tag">
			<HashIcon weight="bold" className={styles.hash} aria-hidden data-flx="feed.feed-topic-tag.hash-icon" />
			<span className={styles.title} data-flx="feed.feed-topic-tag.title">
				{topic.title}
			</span>
		</button>
	);
});
